import { LoaderFunction } from 'react-router-dom';
import { formOrderNaming } from '../../../../../components/forms/NewWorkOrderForm/constants';
import { selectDataForEditCampaignSummary } from '../../../../../gql/selectors/campaigns';
import { createFormDataFromValues } from '../../../../../utils/forms';

// Sentry
import * as Sentry from '@sentry/react';

// Utils
import { claimDraftScope } from '../../../../../utils/draftOwnership';
import { CAMPAIGN_EDIT_SCOPE } from '../../../../../utils/draftScopes';
import { readOwnDraftCopy } from '../../../../../utils/ownedDraftCopy';

const loadDataFromCache = async (formData: FormData) => {
  try {
    const campaignEditData = await selectDataForEditCampaignSummary(formData);

    return campaignEditData;
  } catch (err) {
    Sentry.captureException(err);
    console.log('> Error loading data for edit campaign summary', err);
  }
};

export const LoaderCampaignSummary: LoaderFunction = async ({ params }) => {
  // Mismo dueño que el paso 1: el resumen de la campaña B no lee la copia de A.
  claimDraftScope(CAMPAIGN_EDIT_SCOPE, params.id);

  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  const dataParsed = readOwnDraftCopy(
    formOrderNaming.EDIT_CAMPAIGN_FORM,
    params.id
  );
  if (dataParsed) {
    const formData = createFormDataFromValues(dataParsed);
    const loaderToResolve = await loadDataFromCache(formData);

    return loaderToResolve;
  }

  return {};
};

  return { data: load() };
};
